module.exports = __webpack_public_path__ + "static/img/stab_425.3d761dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/stab_425.jpg
// module id = bmBF
// module chunks = 0